
<section class="breadcrumb-section">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="breadcrumb-title">
                    <h1>Chairman's Message</h1>
                </div>
            </div>
        </div>			
    </div>
</section>      

<section class="section-lg chair-msg">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-8">
                <div class="inner-title"  >
                    <h3>Chairman's Message</h3>							
                   
                </div>
                <div class="text-justify" >
                    <blockquote>“Education is not the learning of facts, but the training of the mind to think”-Albert Einstein</blockquote>
                    <p>This is verbatim applicable to the school of thought which RGI is all about. My Father Lt. Shri Gyanchandji H. Raisoni was a visionary and an inspiration. He aspired for a group of institutions impeccable, excellent and powerful in the context of the Indian society. It is his dream which has been accomplished in the form of The Raisoni Group of Institutions.</p>
                    <p>Over the last few decades, the development of technology and innovation has aided us in refraining from the barriers. It has instilled life to creativity.</p>
                    <p>Presently, the world economy is experiencing an unprecedented change. Our belief lies in our young students. We believe that the awareness imparted to them will continue to grow and sprawl. In order to pave their way, we have a team of highly qualified Educators, Lecturers and Professors. We have the best of infrastructure and a dedicated placement cell. We have established a benchmark for ourselves. Undoubtedly, we are the most preferred institute for students in Central India. We are proud to have developed diverse, creative and team-oriented professionals in the past and will continue to pursue the same in future. The vision of RGI is to provide affordable, relevant, industry-oriented and world-class professional education to all. RGI wishes you to grow and continue on your successful endeavors. I am optimistic that RGI will sustain to be the blistering flame of knowledge and opportunities with the assiduous team we have.</p>
                    <blockquote>“Think Education Think Raisoni”</blockquote>
                </div>
            </div>
            <div class="col-md-4 col-sm-8">
                <div class="team" >
                    <figure><img class="img-fluid" src="assets/images/chairman.webp" alt="Shri. Sunil Raisoni | Ghrcacsn" title="Shri. Sunil Raisoni | Ghrcacsn"> </figure>
                    <div class="team-details">
                        <h5>Shri. Sunil Raisoni</h5> 
                        <h6>Chairman RGI </h6>                                 
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

